// Example release notes, only used when PREVIEW_WITH_EXAMPLES is on in release.service.js.
// They are not real release notes and are never saved anywhere.

export const EXAMPLE_RELEASES = [
  {
    version: "2026.09.1",
    release_date: "2026-09-11",
    is_new: true,
    items: [
      { group: "new", text: "Release notes: see what changed in the portal, with a dot when something is new.", link: "/release_notes" },
      { group: "new", text: "Scroll-depth step in DataLayer Guard scenarios.", link: "" },
    ],
  },
  {
    version: "2026.08.2",
    release_date: "2026-08-26",
    is_new: true,
    items: [
      { group: "improved", text: "Faster Tag Monitor dashboard for large containers.", link: "" },
      { group: "fixed", text: "Timezone shown correctly in alert emails.", link: "" },
    ],
  },
  {
    version: "2026.08.1",
    release_date: "2026-08-07",
    is_new: true,
    items: [
      { group: "new", text: "Market sub-paths for Tag Monitor domains.", link: "" },
      { group: "improved", text: "Clearer error messages when a scenario step fails.", link: "" },
      { group: "fixed", text: "Chart dates no longer skip in the tag volume view.", link: "" },
      { group: "fixed", text: "Saving a DataLayer Guard template no longer resets its name.", link: "" },
    ],
  },
  {
    version: "2026.07.1",
    release_date: "2026-07-15",
    is_new: true,
    items: [{ group: "new", text: "Download Tag Monitor tables as PDF and Excel.", link: "" }],
  },
  {
    version: "2026.06.1",
    release_date: "2026-06-30",
    is_new: false,
    items: [{ group: "new", text: "Consent monitoring filters on the dashboard.", link: "" }],
  },
];

export const EXAMPLE_STATUS = {
  result: true,
  latest_version: EXAMPLE_RELEASES[0].version,
  unseen_count: EXAMPLE_RELEASES.filter((release) => release.is_new).length,
  show_catch_up: true,
  announcement: false,
  release_emails_enabled: true,
};
